// import React from "react";
// import {
//     Box,
//     Button,
//     Grid,
//     Card,
//     CardMedia,
//     IconButton,
//     Radio,
//     Stack,
//     Paper,
//     Typography
// } from "@mui/material";
// import { UploadFile, Close } from "@mui/icons-material";
// import { toast } from "react-toastify";

// const ImageTabContent = ({ productData, setProductData, onNext, onBack }) => {

//     const handleFileChange = (e) => {
//         const files = Array.from(e.target.files);

//         const validFiles = files.filter((file) => {
//             const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];

//             if (!allowedTypes.includes(file.type)) {
//                 toast.error(`${file.name} is not a valid image type`);
//                 return false;
//             }

//             if (file.size > 2 * 1024 * 1024) {
//                 toast.error(`${file.name} must be less than 2MB`);
//                 return false;
//             }

//             return true;
//         });

//         const newImages = validFiles.map((file) => ({
//             id: null,                     // DB id only for existing
//             tempId: Date.now() + Math.random(),  // unique frontend id
//             file,
//             preview: URL.createObjectURL(file),
//             isPrimary: false,
//         }));

//         setProductData((prev) => ({
//             ...prev,
//             images: [...prev.images, ...newImages],
//         }));
//     };

//     const handleRemoveImage = (item) => {

//         setProductData((prev) => ({
//             ...prev,
//             images: prev.images.filter((img) => {

//                 // Existing DB image
//                 if (img.id) {
//                     return img.id !== item.id;
//                 }

//                 // New frontend image
//                 return img.tempId !== item.tempId;
//             }),
//         }));
//     };

//     const handleSetPrimary = (item) => {

//         setProductData((prev) => ({
//             ...prev,
//             images: prev.images.map((img) => {

//                 if (img.id) {
//                     return { ...img, isPrimary: img.id === item.id };
//                 }

//                 return { ...img, isPrimary: img.tempId === item.tempId };
//             }),
//         }));
//     };

//     const handleSaveAndNext = () => {

//         if (!productData.images.length) {
//             toast.error("Please upload at least one image");
//             return;
//         }

//         if (!productData.images.some((img) => img.isPrimary)) {
//             toast.error("Please select one primary image");
//             return;
//         }

//         onNext();
//     };

//     return (
//         <Paper sx={{ p: 4, borderRadius: 3 }}>

//             <Box mb={4}>
//                 <Button
//                     variant="outlined"
//                     component="label"
//                     fullWidth
//                     size="small"
//                     startIcon={<UploadFile />}
//                 >
//                     Select Product Images
//                     <input
//                         hidden
//                         type="file"
//                         multiple
//                         accept="image/*"
//                         onChange={handleFileChange}
//                     />
//                 </Button>
//             </Box>

//             <Grid container spacing={2}>
//                 {productData.images.map((img, index) => (
//                     <Grid item xs={6} sm={4} md={3} key={index}>
//                         <Card sx={{ position: "relative" }}>
//                             <CardMedia
//                                 component="img"
//                                 image={img.preview}
//                                 sx={{ height: 120 }}
//                             />

//                             <IconButton
//                                 size="small"
//                                 sx={{
//                                     position: "absolute",
//                                     top: 6,
//                                     right: 6,
//                                     bgcolor: "#fff"
//                                 }}
//                                 onClick={() => handleRemoveImage(img)}
//                             >
//                                 <Close fontSize="small" />
//                             </IconButton>

//                             <Box
//                                 display="flex"
//                                 alignItems="center"
//                                 justifyContent="center"
//                                 py={0.5}
//                                 bgcolor="#fff"
//                             >
//                                 <Radio
//                                     size="small"
//                                     checked={img.isPrimary}
//                                     onClick={() => handleSetPrimary(img)}
//                                 />
//                                 <Typography variant="caption">
//                                     Primary
//                                 </Typography>
//                             </Box>
//                         </Card>
//                     </Grid>
//                 ))}
//             </Grid>

//             <Stack direction="row" justifyContent="flex-end" spacing={2} mt={4}>
//                 <Button variant="outlined" onClick={onBack}>
//                     Back
//                 </Button>

//                 <Button variant="contained" onClick={handleSaveAndNext}>
//                     Save & Continue
//                 </Button>
//             </Stack>
//         </Paper>

//     );
// };

// export default ImageTabContent;

import React from "react";
import {
    Box,
    Button,
    Grid,
    Card,
    CardMedia,
    IconButton,
    Radio,
    Stack,
    Paper,
    Typography
} from "@mui/material";
import { UploadFile, Close } from "@mui/icons-material";
import { toast } from "react-toastify";

const ImageTabContent = ({ productData, setProductData, onNext, onBack }) => {

    // =============================
    // Upload Images
    // =============================
    const handleFileChange = (e) => {

        const files = Array.from(e.target.files);

        const validFiles = files.filter((file) => {

            const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];

            if (!allowedTypes.includes(file.type)) {
                toast.error(`${file.name} is not valid type`);
                return false;
            }

            if (file.size > 2 * 1024 * 1024) {
                toast.error(`${file.name} must be under 2MB`);
                return false;
            }

            return true;
        });

        const newImages = validFiles.map((file) => ({
            id: null, // existing DB images have id
            tempId: crypto.randomUUID(), // unique frontend id
            file,
            preview: URL.createObjectURL(file),
            isPrimary: false
        }));

        setProductData((prev) => ({
            ...prev,
            images: [...(prev.images || []), ...newImages]
        }));

        e.target.value = null;
    };

    // =============================
    // Remove Image
    // =============================
    const handleRemoveImage = (item) => {

        setProductData((prev) => {

            const filtered = prev.images.filter((img) => {

                // DB image
                if (item.id) {
                    return img.id !== item.id;
                }

                // New image
                return img.tempId !== item.tempId;
            });

            // If removed image was primary → reset all primary
            const removedWasPrimary = item.isPrimary;

            const updated = removedWasPrimary
                ? filtered.map((img) => ({ ...img, isPrimary: false }))
                : filtered;

            return {
                ...prev,
                images: updated
            };
        });
    };

    // =============================
    // Set Primary Image
    // =============================
    const handleSetPrimary = (item) => {

        setProductData((prev) => ({

            ...prev,
            images: prev.images.map((img) => {

                if (item.id) {
                    return {
                        ...img,
                        isPrimary: img.id === item.id
                    };
                }

                return {
                    ...img,
                    isPrimary: img.tempId === item.tempId
                };
            })
        }));
    };

    // =============================
    // Save & Continue
    // =============================
    const handleSaveAndNext = () => {

        if (!productData.images || productData.images.length === 0) {
            toast.error("Upload at least one image");
            return;
        }

        if (!productData.images.some((img) => img.isPrimary)) {
            toast.error("Select one primary image");
            return;
        }
        console.log("images tab data :", productData)

        onNext();
    };

    return (
        <Paper sx={{ p: 4, borderRadius: 3 }}>

            {/* Upload Button */}
            <Box mb={4}>
                <Button
                    variant="outlined"
                    component="label"
                    fullWidth
                    size="small"
                    startIcon={<UploadFile />}
                >
                    Select Product Images
                    <input
                        hidden
                        type="file"
                        multiple
                        accept="image/*"
                        onChange={handleFileChange}
                    />
                </Button>
            </Box>

            {/* Image Grid */}
            <Grid container spacing={2}>
                {(productData.images || []).map((img) => (
                    <Grid
                        item
                        xs={6}
                        sm={4}
                        md={3}
                        key={img.id ? `db-${img.id}` : `temp-${img.tempId}`}
                    >
                        <Card sx={{ position: "relative" }}>

                            <CardMedia
                                component="img"
                                image={img.preview}
                                sx={{ height: 120, objectFit: "cover" }}
                            />

                            {/* Remove Button */}
                            <IconButton
                                size="small"
                                sx={{
                                    position: "absolute",
                                    top: 6,
                                    right: 6,
                                    bgcolor: "#fff"
                                }}
                                onClick={() => handleRemoveImage(img)}
                            >
                                <Close fontSize="small" />
                            </IconButton>

                            {/* Primary Radio */}
                            <Box
                                display="flex"
                                alignItems="center"
                                justifyContent="center"
                                py={0.5}
                                bgcolor="#fff"
                            >
                                <Radio
                                    size="small"
                                    checked={img.isPrimary}
                                    onChange={() => handleSetPrimary(img)}
                                />
                                <Typography variant="caption">
                                    Primary
                                </Typography>
                            </Box>

                        </Card>
                    </Grid>
                ))}
            </Grid>

            {/* Buttons */}
            <Stack direction="row" justifyContent="flex-end" spacing={2} mt={4}>
                <Button variant="outlined" onClick={onBack}>
                    Back
                </Button>

                <Button variant="contained" onClick={handleSaveAndNext}>
                    Save & Continue
                </Button>
            </Stack>

        </Paper>
    );
};

export default ImageTabContent;